import React, { useState } from 'react';
import QATable from './QATable';
import TenderBox from './TenderBox';

const Tenders = () => {
  const [showQATable, setShowQATable] = useState(false);
  return (
    <div
      className="width100 "
      style={{ margin: '20px 0 20px 40px', padding: '0 20px' }}
    >
      <TenderBox
        date="15. Jul  2021."
        dateTo="23/07/2021. do 14 časova."
        title="Usluga organizacije poslovnih susreta “Trebam-Trebaš”"
        documentation="/files/trebam-trebas.zip"
        active={false}
      />
      <TenderBox
        date="15. Jun 2021."
        dateTo="29/06/2021. do 14 časova."
        title="Usluge organizacije certifikovane obuke Zavarivača i obuka CNC operatera"
        documentation="/files/Konkursna_dokumentacija_15_6_2021.zip"
        active={false}
      />
      <TenderBox
        date="15. Jun 2021."
        dateTo="23/06/2021. do 14 časova."
        title="Obuka za nezaposlena lica “Zapošljavanje - Moderan pristup i ulazak na tržište rada”"
        documentation="/files/Konkursna_dokumentacija_23_6_2021.docx"
        active={false}
      />
      <TenderBox
        date="10. Maj 2021."
        dateTo="19/05/2021. do 14 časova."
        title="Usluge certifikacije za sistem menadžmenta prema zahtevima standarda
        ISO 9001, ISO 14001, ISO 45001 OHSAS 18001)"
        documentation="/files/Konkursna_dokumentacija_10_5_2021_3.zip"
        active={false}
      />
      <TenderBox
        date="10. Maj 2021."
        dateTo="18/05/2021. do 14 časova."
        title="Usluga implementacije za sistem menadžmenta prema zahtevima standarda
        ISO 9001, ISO 14001, ISO 45001 (OHSAS 18001)"
        documentation="/files/Konkursna_dokumentacija_10_5_2021_2.zip"
        active={false}
      />
      <TenderBox
        date="10. Maj 2021."
        dateTo="17/05/2021. do 14 časova."
        title="Usluga obuke za interne proveravače za sistem menadžmenta prema
zahtevima standarda ISO 9001,14001 i 45001 (OHSAS 18001)"
        documentation="/files/Konkursna_dokumentacija_10_5_2021_1.zip"
        active={false}
      />
      <div className="tender-box">
        <br />
        <label className="tender-box-highlight ">14. April 2021. </label>
        <br />
        <label>
          {' '}
          <span className="tender-box-highlight ">Predmet nabavke:</span> Usluga
          Obuka za interne proveravače sistema kvaliteta ISO i Uvodjenje i
          certifikacija ISO standarda
        </label>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Rok za podnošenje ponuda:
          </span>{' '}
          29/04/2021. do 14 časova.
        </label>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Konkursnu dokumentaciju za podnošenje ponude možete preuzeti
          </span>{' '}
          <a
            href="/files/Konkursna dokumentacija 8_2021.zip"
            download
            className="font-weight-bold"
          >
            {' '}
            OVDE
          </a>
        </label>

        <br />
        {!showQATable ? (
          <label>
            <span className="tender-box-highlight ">
              Najčešće postavljana pitanja i odgovore možete pogledati
            </span>{' '}
            <span
              className="font-weight-bold open-table"
              onClick={() => setShowQATable(true)}
            >
              {' '}
              OVDE
            </span>
          </label>
        ) : (
          <label>
            <span
              className="font-weight-bold open-table"
              onClick={() => setShowQATable(false)}
            >
              {' '}
              Zatvori tabelu
            </span>
          </label>
        )}
        <div>
          <br />
          <span className="red-circle"></span>
          <label className="tender-box-highlight ml-3">Isteklo</label>
        </div>
        {showQATable && <QATable></QATable>}
      </div>

      <TenderBox
        date="08. April 2021."
        dateTo="15/04/2021. do 14 časova."
        title=" Realizacija “Inovacioni pool” programa i usluga “VMC Klinika”"
        documentation="/files/08_April_Poziv_Obrazac.zip"
        active={false}
      />

      <div className="tender-box">
        <label className="tender-box-highlight ">24. Mart 2021. </label>
        <br />
        <label>
          {' '}
          <span className="tender-box-highlight ">Predmet nabavke:</span> Razvoj
          sertifikovanog programa obuke za vlasnike MSP (malih i srednjih
          preduzeća i preduzetnika) o društvenoj odgovornosti i sprovođenje
          obuke za vlasnike MSP o društveno odgovornom poslovanju.
        </label>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Rok za podnošenje ponuda:
          </span>{' '}
          31/03/2021. do 12 časova.
        </label>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Poziv i Obrazac za podnošenje ponude možete preuzeti ovde:
          </span>{' '}
          <a
            href="/files/Poziv_za_podnosenje_ponuda_u_postupku_nabavke_male_vrednosti_31032021.docx"
            download
            className="font-weight-bold"
          >
            {' '}
            POZIV
          </a>
          <a
            href="/files/Ponuda_za_nabavku_male_vrednosti_31032021.docx"
            download
            className="font-weight-bold"
          >
            {' '}
            OBRAZAC
          </a>
        </label>
        <br />
        <span className="red-circle"></span>
        <label className="tender-box-highlight ml-3">Isteklo</label>
      </div>

      <TenderBox
        date="03. Februar 2021."
        dateTo="10/02/2021. do 14 časova."
        title="Nabavka kancelarijskog nameštaja za kancelariju VMC-Jug u Nišu"
        documentation="/files/podnosenje_ponuda_kanc_materijal.docx"
        active={false}
      />

      <TenderBox
        date="23. Decembar 2020."
        dateTo="30/12/2020. do 14 časova."
        title="Nabavka opreme za kancelariju VMC-Jug u Nišu"
        documentation="/files/ObrazacA-Poziv_za_podnosenje_ponuda_u_postupku_narudzbenice.docx"
        active={false}
      />

      <div className="tender-box">
        <label className="tender-box-highlight ">22. Decembar 2020.</label>
        <br />
        <label>
          {' '}
          <span className="tender-box-highlight ">Predmet nabavke:</span> Usluga
          izrade promotivnog materijala i PR - /Visibility/ i organizacije
          informativne kampanje “Budi bolji – udružuj se”
        </label>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Rok za podnošenje ponuda:
          </span>{' '}
          29.12.2020. do 14 časova.
        </label>
        <br />
        <label>
          <span className="tender-box-highlight ">
            Poziv i Obrazac za podnošenje ponude možete preuzeti ovde:
          </span>
          <a
            href="/files/Poziv_za_podnosenje_ponuda_u_postupku_nabavke_male_vrednosti.docx"
            download
            className="font-weight-bold"
          >
            {' '}
            POZIV
          </a>
          <a
            href="/files/Obrazac-Ponuda_za_nabavku_male_vrednosti.docx"
            download
            className="font-weight-bold"
          >
            {' '}
            OBRAZAC
          </a>
        </label>
        <br />
        <span className="red-circle"></span>
        <label className="tender-box-highlight ml-3">Isteklo</label>
      </div>

      <TenderBox
        date="19. Novembar 2020."
        dateTo="26/11/2020 do 14 časova."
        title="Zakup
        poslovnog prostora u Nišu (Kancelarija VMC - Jug )"
        documentation="/files/Obrazac-A-NABAVKA1_2020.docx"
        active={false}
      />
    </div>
  );
};

export default Tenders;
